<kendo-arcgauge class="gauge" [value]="input" [colors]="colors">
  <ng-template kendoArcGaugeCenterTemplate let-value="value">
    {{ value }} %
  </ng-template>
</kendo-arcgauge>
<div class="gauge-description">
  {{ description }}
</div>
